import React from 'react';
import useQuery from '../../../app/common/util/hooks';
import { observer } from 'mobx-react-lite';
import {
    Formik,
    Form,
    Field,
    ErrorMessage
} from 'formik';
import { resetPasswordSchema } from '../../../app/common/formValidations/validationSchemes';
import { IUserResetPasswordForm } from '../../../app/models/user';
import { COLORS } from '../../../app/styles/colors.js';
import { useStore } from '../../../app/stores/store';
import { Button, FormControl, Grid, InputAdornment, OutlinedInput, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { withNavbar } from '../../../app/layout/HOC';

const styles = {
    root: {
        margin: '0 auto',
        width: 380,
        height: 360,
        padding: '30px 50px',
        marginTop: 200,
        boxShadow: '3px 3px 7px 1px #ccc',
        background: '#FFFFFF',
        '& h5': {
            marginBottom: 40,
            marginTop: 25,
            color: COLORS.darkGrey,
            fontWeight: 500,
        },
    } as const,
    backgroundPic: {
        marginTop: 50,
        backgroundRepeat: 'no-repeat',
        minHeight: '100%',
        width: '100%',
        height: 'auto',
        position: 'fixed',
        top: 0,
        left: 100,
        zIndex: -1,
    },
    textFieldStyle: {
        width: '100%',
        height: '39px',
        letterSpacing: '3px',
    },
    label: {
        marginBottom: 10,
        marginTop: 30,
        fontSize: '0.75rem',
        color: COLORS.darkGrey,
    },
    displayCursor: {
        cursor: 'pointer'
    },
    text: {
        fontSize: '0.75rem',
        color: COLORS.orange,
    },
    container: {
        width: '100%'
    }
};


const ResetPasswordForm  = () => {
    const { userStore } = useStore();
    const { resetPassword } = userStore;
    const email = useQuery().get('email') as string;
    const token = useQuery().get('token') as string;
    const initialValues: IUserResetPasswordForm = { newPassword: '', confirmPassword: '', showNewPassword: false, 
    showConfirmPassword: false };

    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };
    return (
        <div>
            <Grid container >
                <div style={styles.root}>
                    <Typography variant="h5">Reset password</Typography>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={resetPasswordSchema}
                        onSubmit={(values, { setSubmitting }) => {
                            resetPassword(token as string, email as string, values.newPassword, values.confirmPassword);
                            setSubmitting(false);
                        }}
                    >
                        {({ values,
                            handleChange,
                            handleBlur,
                            isSubmitting, setValues }) => {
                            return (
                                <Form style={styles.container} autoComplete='off'>
                                    <FormControl fullWidth>
                                        <label style={styles.label}>New Password</label>
                                        <Field
                                            type={values.showNewPassword ? "text" : "password"}
                                            component={OutlinedInput}
                                            id="newPassword"
                                            name="newPassword"
                                            placeholder="Password"
                                            onChange={handleChange}
                                            value={values.newPassword}
                                            variant="outlined"
                                            size="small"
                                            style={styles.textFieldStyle}
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle newpassword visibility"
                                                        onClick={(e) => {
                                                            setValues({
                                                                ...values,
                                                                showNewPassword: !values.showNewPassword,
                                                            });
                                                        }}
                                                        onMouseDown={handleMouseDownPassword}
                                                        edge="end"
                                                    >
                                                        {values.showNewPassword ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>
                                            }
                                        />
                                        <ErrorMessage name="newPassword" component="div" />
                                    </FormControl>
                                    <FormControl fullWidth>
                                        <label style={styles.label}>Confirm Password</label>
                                        <Field
                                            type={values.showConfirmPassword ? "text" : "password"}
                                            component={OutlinedInput}
                                            id="confirmPassword"
                                            name="confirmPassword"
                                            placeholder="Confirm Password"
                                            size="small"
                                            onChange={handleChange}
                                            variant="outlined"
                                            style={styles.textFieldStyle}
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle confirmpassword visibility"
                                                        onClick={(e) => {
                                                            setValues({
                                                                ...values,
                                                                showConfirmPassword: !values.showConfirmPassword,
                                                            });
                                                        }}
                                                        onMouseDown={handleMouseDownPassword}
                                                        edge="end"
                                                    >
                                                        {values.showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>
                                            }
                                        />
                                        <ErrorMessage name="confirmPassword" component="div" />
                                    </FormControl>
                                    <Button sx={{ mt: 2 }} type="submit" fullWidth variant="contained"> Save</Button>
                                </Form>
                            );
                        }}
                    </Formik>
                    {(email === '' || token === '') &&
                        <p>Something went wrong</p>
                    }
                </div>
            </Grid>
        </div >

    )
}
const ResetPasswordFormPage = withNavbar(observer(ResetPasswordForm));
export default ResetPasswordFormPage;